import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { authGuard } from '../services/guards/auth-guard'
import { AdminRoleGuard } from '../services/role-guard.service'
import { AppleIntegrationComponent } from './apple-integration.component'

const routes: Routes = [
  {
    path: 'integrations/apple',
    component: AppleIntegrationComponent,
    canActivate: [authGuard, AdminRoleGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProviderIntegrationRoutingModule {}
